jQuery(document).ready(function ($) {
	// Check if we have the required AJAX object
	if (typeof wc_add_to_cart_params === 'undefined') {
		console.error('WooCommerce parameters not loaded');
		return;
	}

	// Check if we have the required nonce
	if (typeof wc_add_to_cart_params.asba_checkout_nonce === 'undefined') {
		console.error('Checkout nonce not loaded');
		return;
	}

	// --- WooCommerce Params Checks ---
	if (
		typeof wc_add_to_cart_params.wc_ajax_url === 'undefined' &&
		typeof wc_add_to_cart_params.ajax_url !== 'undefined'
	) {
		// Provide wc_ajax_url if missing and ajax_url is available
		wc_add_to_cart_params.wc_ajax_url =
			wc_add_to_cart_params.ajax_url.replace(
				'/admin-ajax.php',
				'/?wc-ajax=%%endpoint%%'
			);
		// Note: The replace logic might need adjustment based on your site's URL structure.
		// Using admin-ajax.php directly as in your AJAX call is also common.
	} else if (
		typeof wc_add_to_cart_params.wc_ajax_url === 'undefined' &&
		typeof wc_add_to_cart_params.ajax_url === 'undefined'
	) {
		console.error('Cannot determine WooCommerce AJAX URL.');
		// Maybe provide a default fallback if critical?
		// wc_add_to_cart_params.ajax_url = '/wp-admin/admin-ajax.php';
	}

	// --- Retail Product Definitions ---
	const retailProductIds = [4345, 4348, 4351];

	function isRetailProduct(productId) {
		// Ensure comparison is consistent (e.g., both numbers)
		return retailProductIds.includes(parseInt(productId, 10));
	}

	// --- Cart Page Specific Functions ---

	// Check if we're on the order-received page
	const isOrderReceived = $('body').hasClass('woocommerce-order-received');

	function cartHasRetailBag() {
		// Check if we already have the class on body
		if (document.body.classList.contains('has-retail-bags')) {
			return true;
		}

		// Check if we're on the order-received page
		const isOrderReceived = document.body.classList.contains(
			'woocommerce-order-received'
		);

		if (isOrderReceived) {
			// Get order ID from URL path
			const pathParts = window.location.pathname.split('/');
			const orderIndex = pathParts.indexOf('order-received');
			const orderId =
				orderIndex !== -1 && pathParts[orderIndex + 1]
					? pathParts[orderIndex + 1]
					: null;

			if (orderId) {
				// Make AJAX request to check for retail bags
				jQuery.ajax({
					url: wc_add_to_cart_params.ajax_url,
					type: 'POST',
					data: {
						action: 'asba_check_retail_bags',
						security: wc_add_to_cart_params.asba_checkout_nonce,
						is_order_received: 'true',
						order_id: orderId,
					},
					success(response) {
						if (response.success && response.data.has_retail_bags) {
							document.body.classList.add('has-retail-bags');
						}
					},
					error() {
						// Fallback to DOM-based detection if AJAX fails
						const orderDetails = document.querySelector(
							'.woocommerce-order-details'
						);
						if (orderDetails) {
							const hasRetailBag = orderDetails
								.querySelector('.product-name')
								?.textContent.includes('Skip Bag');
							if (hasRetailBag) {
								document.body.classList.add('has-retail-bags');
							}
						}
					},
				});
			}
		} else {
			// Check cart items
			const cartItems = document.querySelectorAll(
				'.woocommerce-cart-form__cart-item'
			);
			for (const item of cartItems) {
				const productName =
					item.querySelector('.product-name')?.textContent;
				if (productName && productName.includes('Skip Bag')) {
					document.body.classList.add('has-retail-bags');
					break;
				}
			}
		}
	}

	// Check page type and run appropriate functions
	function checkPageType() {
		const isCart = document.body.classList.contains('woocommerce-cart');
		const isCheckout = document.body.classList.contains(
			'woocommerce-checkout'
		);
		const isOrderReceived = document.body.classList.contains(
			'woocommerce-order-received'
		);

		if (isCart || isCheckout || isOrderReceived) {
			toggleTextEditorVisibility();
		}
	}

	// Toggle visibility of text editors based on retail bag presence
	function toggleTextEditorVisibility() {
		if (cartHasRetailBag()) {
			document.body.classList.add('has-retail-bags');
		}
	}

	// Toggle visibility of shipping elements based on retail bag presence
	function toggleShippingElementsVisibility() {
		const hasRetailBags =
			document.body.classList.contains('has-retail-bags');
		const shippingElements = document.querySelectorAll(
			'.woocommerce-shipping-totals'
		);

		shippingElements.forEach((element) => {
			if (hasRetailBags) {
				element.style.display = ''; // Show shipping for retail bags
			} else {
				element.style.display = 'none'; // Hide shipping for non-retail bags
			}
		});
	}

	// Run on page load and ensure it runs after WooCommerce is ready
	jQuery(document).ready(function ($) {
		// Initial check
		toggleShippingElementsVisibility();

		// Also run after a short delay to ensure WooCommerce has initialized
		setTimeout(toggleShippingElementsVisibility, 500);

		// Handle checkout page specific behavior
		if ($('body').hasClass('woocommerce-checkout')) {
			// Watch for changes to the order review section
			const orderReviewObserver = new MutationObserver(function (
				mutations
			) {
				mutations.forEach(function (mutation) {
					if (
						mutation.type === 'childList' &&
						mutation.addedNodes.length > 0
					) {
						toggleShippingElementsVisibility();
					}
				});
			});

			// Start observing the order review section
			const orderReview = document.getElementById('order_review');
			if (orderReview) {
				orderReviewObserver.observe(orderReview, {
					childList: true,
					subtree: true,
				});
			}
		}
	});

	// Run on AJAX cart updates
	jQuery(document.body).on('wc_fragments_refreshed', function () {
		checkPageType();
		toggleShippingElementsVisibility();
	});

	// Also run when cart is updated via AJAX
	jQuery(document.body).on('added_to_cart removed_from_cart', function () {
		setTimeout(toggleShippingElementsVisibility, 500);
	});

	// Handle checkout page updates
	jQuery(document.body).on('updated_checkout', function () {
		toggleShippingElementsVisibility();
	});

	// --- Global Functions (Can be called from anywhere) ---

	function displayRetailBagNotice() {
		// Simple check to prevent adding multiple notices
		if (
			$(
				'.buy-bags-online-popup .woocommerce-error:contains("Skip Bags must be purchased")'
			).length > 0
		) {
			// Set SVG fill color and position.
			$('.buy-bags-online-popup .dialog-close-button').css({
				top: '2em',
				right: '2em',
			});
			$('.buy-bags-online-popup .dialog-close-button svg').css({
				fill: '#fff',
			});

			return;
		}
		const noticeHtml = `
            <div class="woocommerce-notices-wrapper">
                <ul class="woocommerce-error" role="alert">
                    <li>Skip Bags must be purchased separately. Kindly complete or clear your current cart first.</li>
                </ul>
            </div>
        `;
		// Ensure the target element exists before prepending
		const $targetHeading = $(
			'.buy-bags-online-popup .elementor-widget-heading'
		).first();
		if ($targetHeading.length) {
			$targetHeading.before(noticeHtml);

			// Set SVG fill color and position.
			$('.buy-bags-online-popup .dialog-close-button').css({
				top: '2em',
				right: '2em',
			});
			$('.buy-bags-online-popup .dialog-close-button svg').css({
				fill: '#fff',
			});
			if ($('body').attr('data-elementor-device-mode') === 'mobile') {
				// Fallback: Scroll to the notice after it's inserted
				setTimeout(function () {
					const $notice = $(
						'.buy-bags-online-popup .woocommerce-notices-wrapper'
					);
					if ($notice.length) {
						// Scroll the notice into view
						$notice[0].scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
					}
				}, 100); // Small delay to ensure DOM is updated
			}
		} else {
			console.warn(
				'Could not find target heading to display retail bag notice.'
			);
			// Fallback: maybe display it elsewhere?
			// $('.buy-bags-online-popup').prepend(noticeHtml);
		}
	}

	// --- Execution Logic ---

	// Wrapper function to run visibility toggle ONLY on the cart or checkout page
	function maybeToggleTextEditorVisibility() {
		if (
			$('body').hasClass('woocommerce-cart') ||
			$('body').hasClass('woocommerce-checkout') ||
			$('body').hasClass('woocommerce-order-received')
		) {
			toggleTextEditorVisibility();
		}
	}

	// Handle dialog close button click.
	$(document).on(
		'click',
		'.buy-bags-online-popup .dialog-close-button',
		function () {
			$('.buy-bags-online-popup .dialog-close-button').css({
				top: '1em',
				right: '1em',
			});
			$('.buy-bags-online-popup .dialog-close-button svg').css({
				fill: 'rgb(0, 0, 0)',
			});
			$('.archive.woocommerce #primary').css('display', 'none');
			localStorage.removeItem('postcode_valid'); // Clear validity state
		}
	);

	// Handle popup background click.
	$(document).on('click', '.buy-bags-online-popup', function (e) {
		// Only trigger if clicking the background itself, not its children
		if (e.target === this) {
			$('.buy-bags-online-popup .dialog-close-button').css({
				top: '1em',
				right: '1em',
			});
			$('.buy-bags-online-popup .dialog-close-button svg').css({
				fill: 'rgb(0, 0, 0)',
			});
			$('.archive.woocommerce #primary').css('display', 'none');
			localStorage.removeItem('postcode_valid'); // Clear validity state
		}
	});

	// Initial check on page load (only applies if on cart page)
	maybeToggleTextEditorVisibility();

	// Handle cart updates via fragments (only applies if on cart page)
	$(document.body).on('wc_fragments_refreshed', function () {
		maybeToggleTextEditorVisibility();
	});

	// --- Add to Cart AJAX Handling (Remains Global) ---
	// This needs to work globally because the button is in a popup (#Retail-Sales)
	// which can be opened from any page.
	$('body').on(
		'click',
		'#Retail-Sales .single_add_to_cart_button',
		function (e) {
			const $button = $(this);
			const productId = $button.val();

			// Only intercept for specific retail products
			if (isRetailProduct(productId)) {
				e.preventDefault(); // Prevent default form submission via button type=submit
				e.stopPropagation(); // Prevent event bubbling

				const $form = $button.closest('form.cart');
				if (!$form.length) {
					console.error(
						'Could not find parent form for add-to-cart button.'
					);
					alert('An error occurred. Could not process request.');
					return false;
				}

				// More robust quantity selector within the specific form
				// const quantity = $form.find('input[name="quantity"]').val() || 1;
				const quantity =
					$button
						.closest('.e-atc-qty-button-holder')
						.find('input[name="quantity"]')
						.val() || 1;

				// Nonce check - ensure wc_add_to_cart_params.nonce is correctly generated (action: 'add-to-cart')
				if (!wc_add_to_cart_params || !wc_add_to_cart_params.nonce) {
					console.error('Add to cart nonce not available.');
					alert(
						'Security check failed. Please refresh the page and try again.'
					);
					return false;
				}
				if (!wc_add_to_cart_params.ajax_url) {
					console.error('AJAX URL not available.');
					alert(
						'Cannot connect to server. Please refresh the page and try again.'
					);
					return false;
				}

				$.ajax({
					url: wc_add_to_cart_params.ajax_url, // Use admin-ajax.php
					type: 'POST',
					data: {
						action: 'woocommerce_add_to_cart',
						product_id: productId,
						quantity,
						// Security nonce - *MUST* match the action expected by WC_AJAX::add_to_cart handler
						// which is 'add-to-cart' when checking the 'security' parameter.
						security: wc_add_to_cart_params.nonce,
					},
					beforeSend() {
						$button.prop('disabled', true).addClass('loading');
					},
					success(response) {
						// Check if response is valid and has fragments (indicating success even if notices are present)
						// WooCommerce AJAX add-to-cart often returns fragments on success.
						const success = response && response.fragments;

						if (!success) {
							console.error('Add to cart failed.', response);
							// Handle error - Check specific structure of error response
							// WooCommerce often returns { success: false, data: { error: 'message' } } OR html notices
							let errorMessage =
								'An error occurred while adding the product to cart.'; // Default message

							if (
								response &&
								response.data &&
								typeof response.data === 'string'
							) {
								// Sometimes WC returns error HTML directly in data
								const $errorHtml = $(response.data);
								errorMessage =
									$errorHtml
										.find('.woocommerce-error li')
										.first()
										.text() || errorMessage;
							} else if (
								response &&
								response.data &&
								response.data.error &&
								typeof response.data.error === 'string'
							) {
								// Or sometimes structured { data: { error: '...' } }
								errorMessage = response.data.error;
							}

							// Check if this is the specific retail bag validation message
							if (
								errorMessage.includes(
									'Skip Bags must be purchased'
								)
							) {
								displayRetailBagNotice();
							} else {
								// Display a generic or the specific error found
								alert(errorMessage);
							}
						} else {
							// Success
							$(document.body).trigger('wc_fragment_refresh'); // Standard WC hook to refresh fragments
							// Optional: Redirect only on success
							window.location.href =
								wc_add_to_cart_params.cart_url;
							// Or maybe just close the popup and let fragments update? Depends on UX goal.
							// console.log('Product added successfully.');
							// If you have a popup close function:
							// closeRetailSalesPopup();
						}
					},
					error(xhr, status, error) {
						console.error('AJAX Error:', status, error, xhr);
						alert(
							'Error communicating with the server. Please try again.'
						);
					},
					complete() {
						// Re-enable the button
						$button.prop('disabled', false).removeClass('loading');
					},
				});

				return false; // Extra safety to prevent default form submission
			}
			// If not a retail product, let the default button/form action proceed
		}
	);

	// Prevent form submission *directly* for these products if AJAX is bypassed/failsafe
	// This might be redundant if the button click handler always prevents default, but adds safety.
	$('body').on('submit', '#Retail-Sales form.cart', function (e) {
		// Find the button within the submitted form to get the product ID
		const $button = $(this).find('button[name="add-to-cart"]');
		if ($button.length) {
			const productId = $button.val();
			if (isRetailProduct(productId)) {
				// We already handle this via AJAX click handler, prevent default submission
				e.preventDefault();
				e.stopPropagation();
				// console.log('Form submission prevented for retail product, handled by AJAX click.');
				return false;
			}
		}
		// Allow form submission for non-retail products or if button not found
	});

	jQuery(document).ready(function ($) {
		const form = $('.tm-postcode-popup-retail-sales-form');

		// If form not found immediately, try again after a short delay
		if (!form.length) {
			setTimeout(function () {
				const delayedForm = $('.tm-postcode-popup-retail-sales-form');
				if (delayedForm.length) {
					setupForm(delayedForm);
				}
			}, 500);
		} else {
			setupForm(form);
		}

		function setupForm(form) {
			// Check if the hidden input already exists to prevent duplicates
			if (!$('input[name="check_popup_postcode_nonce"]').length) {
				// Create and append the hidden input field for the nonce
				const nonceInput = $('<input>', {
					type: 'hidden',
					name: 'check_popup_postcode_nonce',
					value: popupNonce.check_popup_postcode_nonce, // Use localized nonce
				});
				form.append(nonceInput);
			}
		}

		// Hide error message on focus
		$(document).on('focus', '#tm-popup-postcode', function () {
			$(this).val('');
			$('#tm-popup-postcode-error').fadeOut(1500);
		});

		// Attach the submit event to handle form submission
		$(document).on(
			'submit',
			'.tm-postcode-popup-retail-sales-form',
			function (e) {
				e.preventDefault();
				const postcode = $('#tm-popup-postcode').val().trim();
				let nonce = $('input[name="check_popup_postcode_nonce"]').val();

				// Fallback: if nonce field doesn't exist, get it directly from popupNonce
				if (
					!nonce &&
					typeof popupNonce !== 'undefined' &&
					popupNonce.check_popup_postcode_nonce
				) {
					nonce = popupNonce.check_popup_postcode_nonce;
				}

				$('.in-progress').fadeIn(200); // Show loading indicator
				$('#tm-popup-postcode-error').text('').hide();

				$.ajax({
					url: popupNonce.ajaxurl,
					method: 'POST',
					data: {
						action: 'check_popup_postcode',
						postcode,
						nonce,
					},
					success(response) {
						handleResponse(response);
					},
					error(xhr, status, error) {
						handleError();
					},
				});
			}
		);

		function handleResponse(response) {
			if (response.success) {
				$('.in-progress').fadeOut(500); // Hide loading indicator
				$('#tm-popup-postcode').val('');
				$('#tm-popup-postcode-error')
					.css('color', 'green')
					.text('Area serviced, please find prices below.')
					.fadeIn(500);

				// Check stock status and show appropriate UI for each product
				if (response.data.stock_status) {
					const stockStatus = response.data.stock_status;

					// Handle each product individually
					Object.entries(stockStatus).forEach(
						([productId, inStock]) => {
							const $productContainer = $(
								`.popup-product-${productId} .elementor-widget-container`
							);

							if (inStock) {
								// Show add to cart widget for this product
								$productContainer.fadeIn(500);
								// Remove any existing out of stock message for this product
								$(
									`.popup-product-${productId} .popup-out-of-stock-message`
								).remove();
							} else {
								// Hide add to cart widget and show out of stock message
								$productContainer.fadeOut(500);
								showOutOfStockMessageForProduct(productId);
							}
						}
					);
				} else {
					// Fallback to original behavior - show all products
					$(
						'.popup-book-online-btn .elementor-widget-container'
					).fadeIn(500);
				}

				localStorage.setItem('postcode_valid', 'true');
			} else {
				$('.in-progress').fadeOut(500);
				$('#tm-popup-postcode-error')
					.css('color', 'red')
					.text(response.data.message)
					.fadeIn(500);

				// Remove all out-of-stock messages
				$('.popup-out-of-stock-message').remove();

				$('.popup-book-online-btn .elementor-widget-container').css(
					'display',
					'none'
				);
				$('.archive.woocommerce #primary').css('display', 'none');
				localStorage.removeItem('postcode_valid'); // Clear validity state
				if (response.data.do_not_serviced_popup) {
					setTimeout(function () {
						elementorProFrontend.modules.popup.showPopup({
							id: 3197,
						});
					}, 1500); // 1.5 seconds delay
				} else {
					console.log('Popup triggering failed:', response.data);
				}
			}
		}

		function showOutOfStockMessageForProduct(productId) {
			// Remove existing out of stock message for this product
			$(
				`#popup-widget-product-${productId} .popup-out-of-stock-message`
			).remove();

			const message = 'Sorry, out of stock.';

			// Create out of stock message element for this specific product
			const $outOfStockElement = $(`
				<div class="popup-out-of-stock-message">
					${message}
				</div>
			`);

			// Insert the message after the product container
			$(`#popup-widget-product-${productId}`).append($outOfStockElement);
			$outOfStockElement.fadeIn(500);
		}

		function handleError() {
			$('.in-progress').fadeOut(500);
			$('#tm-popup-postcode-error')
				.text('Error fetching pricing. Please try again.')
				.fadeIn(500);
			$('.popup-book-online-btn .elementor-widget-container').fadeOut(
				500
			);
		}
	});
});
